<template>
    <page>
        <module>
            <div class="guide-detail">
                <!-- 标题 -->
                <h1 class="guide-title">{{ title }}</h1>
                <!-- 发布时间> -->
                <p class="guide-time">发布时间：{{ publish_time }}</p>
                <!-- 横向分割线 -->
                <div class="guide-line"></div>
                <!-- 文章内容 -->
                <div class="guide-content" v-html="content"></div>
            </div>
        </module>
    </page>
</template>

<script>
export default {
    name: 'platform_notice_detail',

    props: {
        id: String
    },

    data() {
        return {
            title: '',//标题
            content: '',// 内容
            publish_time: ''
        }
    },

    computed: {

    },

    watch: {
        id() {
            this.getDetail();
        },
    },

    mounted() {
        if (this.id) {
            this.getDetail();
        }
    },

    methods: {
        getDetail() {
            this.request({
                url: '/platform/notice/detail',
                data: {
                    id: this.id
                },
                loading: true,
                success: data => {
                    this.title=data.title;
                    this.content=data.content;
                    this.publish_time=data.publish_time;
                }
            });
        }
    }
}
</script>

<style scoped>
.guide-detail {
    padding: 20px;
    width: 1000px;
    margin: 0 auto;
}

.guide-title {
    text-align: center;
    margin-bottom: 30px;
    color: #333;
    font-size: 28px;
    font-weight: bold;
}
.guide-time {
    text-align: left;
    margin-bottom: 10px;
    color: #999;
    font-size: 14px;
}
.guide-line {
    width: 100%;
    height: 1px;
    background-color: #ddd;
    margin-bottom: 30px;
}

.video-section {
    margin-bottom: 30px;
    text-align: center;
}

.guide-content {
    line-height: 1.9;
    color: #555;
    font-size: 16px;
    padding: 15px;
    word-break: break-word;
    word-wrap: break-word;
    text-indent: 2em;
}


</style>
